import { format, isSameDay, parse } from 'date-fns';
import firebase from 'firebase/compat/app';
//import firebase from 'firebase'
//import firebase from 'firebase/compat/app';

export const checkComponentPresence = (el, lt, param, paramb) => {
	//console.log(el, lt, param)
	if (!param) {
		param = 'id'
	}
	if (!paramb) {
		paramb = param
	}
	const _list = lt || []

	for (let c = 0; c < _list.length; c++) {
		//		console.log(el[param], list[c][param])
		if (el[param] === _list[c][paramb]) {
			//console.log("c", el[param], c)
			return c
		}
	}
	return -1
}
////////////////////////////////////////////////////////////////////////////////////////////////////////
export const getSelectedElement = (id, list, comparevalue, is_int) => {
	if (!comparevalue) {
		comparevalue = 'Id'
	}
	try {

		if (is_int) {
			const _id = parseInt(id)
			for (let e = 0; e < list.length; e++) {
				if (parseInt(list[e][comparevalue]) === _id) {
					return list[e]
				}
			}

		} else {
			for (let e = 0; e < list.length; e++) {
				if (list[e][comparevalue] === id) {
					return list[e]
				}
			}

		}
	} catch (err) {
		//console.log(err) 
	}
	return {}
}

////////////////////////////////////////////////////////////////////////////////////////////////////////
export const getJsonConfig = (machine, container_dict, component_dict) => {
	let mcomponent_dict = {}
	let mcontainer_dict = {}
	let component_list = []
	let container_list = []

	for (const m of machine.mixing_list) {
		console.log("one mixxing", m)
		const container = container_dict[m.container_id]
		mcontainer_dict[m.container_id] = {
			name: container.name,
			id: container.id,
			description: container.description,
			net_weight: parseInt(container.net_weight) + parseInt(container.empty_weight),
			full_product_weight: parseInt(container.net_weight),
			empty_weight: container.empty_weight,
		}
		console.log("CONTAINER", container)
		for (const mi of m.mixing_list) {
			const c = component_dict[mi.component_id]
			mcomponent_dict[mi.component_id] = {
				id: mi.component_id,
				name: c.name_multilanguage && c.name_multilanguage[machine.default_language] ? c.name_multilanguage[machine.default_language] : c.name,
				description: c.description_multilanguage && c.description_multilanguage[machine.default_language] ? c.description_multilanguage[machine.default_language] : c.description,
				tank_color: c.color
			}
		}
	}
	console.log("CONTAINER", mcontainer_dict)

	component_list = Object.values(mcomponent_dict)
	container_list = Object.values(mcontainer_dict)

	const json_data = {
		...machine,
		containers: container_list,
		components: component_list,
		mixing_list: machine.mixing_list.filter(m => m.has_chlorine).length > 0 ?
			machine.mixing_list.map(m => {
				return {
					name: m.name_multilanguage && m.name_multilanguage[machine.default_language] ? m.name_multilanguage[machine.default_language] : m.name,
					description: m.description_multilanguage && m.description_multilanguage[machine.default_language] ? m.description_multilanguage[machine.default_language] : m.description,
					button_color: m.button_color,
					has_chlorine: m.has_chlorine,
					chlorine_ppm: m.chlorine_ppm,
					container_id: m.container_id,
					id: m.id,
					mixing_list: m.mixing_list
				}
			})
			:
			machine.mixing_list.map(m => {
				return {
					name: m.name_multilanguage && m.name_multilanguage[machine.default_language] ? m.name_multilanguage[machine.default_language] : m.name,
					description: m.description_multilanguage && m.description_multilanguage[machine.default_language] ? m.description_multilanguage[machine.default_language] : m.description,
					button_color: m.button_color,
					container_id: m.container_id,
					id: m.id,
					mixing_list: m.mixing_list
				}
			})
		,
		//		lastServerConfigUpdate: new Date().getTime()
	}
	console.log("JSON", json_data)
	return json_data
}

///////////////////////////////////////////////////////////////////////////////////////////////////////////////
export function areEqualContain(array1, array2) {
	if (array1.length === array2.length) {
		return array1.every(element => {
			if (array2.includes(element)) {
				return true;
			}

			return false;
		});
	}

	return false;
}
export function areEqual(array1, array2) {
	if (array1.length === array2.length) {
		return array1.every((element, index) => {
			if (element === array2[index]) {
				return true;
			}

			return false;
		});
	}

	return false;
}

////////////////////////////////////////////////////////////////////////////////////////////////////////
export const propComparator = (propName, st) =>
	(a, b) => a[propName] === b[propName] ? 0 : a[propName] < b[propName] ? -1 : 1


////////////////////////////////////////////////////////////////////////////////////////////////////////
export const propComparatorB = (propName, st, propNameB) =>
	(a, b) =>
		(a[propName] ? a[propName][st] : a[propNameB]) === (b[propName] ? b[propName][st] : b[propNameB]) ? 0
			: (a[propName] ? a[propName][st] : a[propNameB]) < (b[propName] ? b[propName][st] : b[propNameB]) ? -1 : 1

const isPropValuesEqual = (subject, target, propName) => {
	return subject.id === target.id
}



export const propComparatorDate = (propName, reverse, propSecondary) => {
	console.log(propName,propSecondary,)
	if (reverse) {
		return (a, b) => 
			isSameDay(myTimestampToDate(a[propName]),myTimestampToDate(b[propName]) )? 
		//0 
		propSecondary? a[propSecondary]===b[propSecondary]?0
			: a[propSecondary]<b[propSecondary] ? -1 : 1 :0 
		: myTimestampToDate(a[propName]) > myTimestampToDate(b[propName]) ? -1 : 1
	} else {
		return (a, b) => isSameDay(myTimestampToDate(a[propName]), myTimestampToDate(b[propName])) ? 
		//0 
		propSecondary? a[propSecondary]===b[propSecondary]?0:a[propSecondary]<b[propSecondary]?-1:1 :0 
		: myTimestampToDate(a[propName]) < myTimestampToDate(b[propName]) ? -1 : 1
	}
}


export const propComparatorDateTime = (propName, reverse, propSecondary) => {
	if (reverse) {
		return (a, b) => 
			myTimestampToDate(a[propName]) === myTimestampToDate(b[propName] )? 
		//0 
		propSecondary? a[propSecondary]===b[propSecondary]?0
			: a[propSecondary]<b[propSecondary] ? -1 : 1 :0 
		: myTimestampToDate(a[propName]) > myTimestampToDate(b[propName]) ? -1 : 1
		
	} else {
		return (a, b) => myTimestampToDate(a[propName]) === myTimestampToDate(b[propName]) ? 
		//0 
		propSecondary? a[propSecondary]===b[propSecondary]?0:a[propSecondary]<b[propSecondary]?-1:1 :0 
		: myTimestampToDate(a[propName]) < myTimestampToDate(b[propName]) ? -1 : 1
	}
}


////////////////////////////////////////////////////////////////////////////////////////////////////////
export const getUniqueItemsByProperties = (items, propName) => {

	return items.filter((item, index, array) =>
		{
			return index === array.findIndex(foundItem => isPropValuesEqual(foundItem, item, propName))
		}
	);
};

////////////////////////////////////////////////////////////////////////////////////////////////////////
/**
 * return javascript Date() object or original object (new Date if empty)
 * @param {d} d date in Timestamp format (from firebase) 
 */
export const getMyDate = (d) => {
	if (d) {
		let myd = d
		try {
			if (d._seconds) {
				d = new Date()//firebase.firestore.Timestamp(d._seconds, d._nanoseconds)
			}
			myd = d.toDate()
		} catch (err) {
			//			console.error("date error conversion", err, d, myd)
		}
		return myd
	} else {
		//	console.error("date error conversion(NO DATE)",d)
		return new Date()
	}
}


////////////////////////////////////////////////////////////////////////////////////////////////////////
export const getLangName = (element, locale) => {
	if (element.name_multilanguage && element.name_multilanguage[locale]) {
		return element.name_multilanguage[locale]
	} else {
		return element.name
	}
}

////////////////////////////////////////////////////////////////////////////////////////////////////////
export const getLangDescription = (element, locale) => {
	if (element.description_multilanguage && element.description_multilanguage[locale]) {
		return element.description_multilanguage[locale]
	} else {
		return element.description
	}
}


////////////////////////////////////////////////////////////////////////////////////////////////////////
export const makeid = (length, only_number) => {
	var result = '';
	let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	if (only_number) {
		characters = '0123456789';
	}
	var charactersLength = characters.length;
	for (var i = 0; i < length; i++) {
		result += characters.charAt(Math.floor(Math.random() * charactersLength));
	}
	return result;
}




////////////////////////////////////////////////////////////////////////////////////////////////////////
export const convertBase64 = (file) => {
	return new Promise((resolve, reject) => {
		const fileReader = new FileReader();
		fileReader.readAsDataURL(file)
		fileReader.onload = () => {
			resolve(fileReader.result);
		}
		fileReader.onerror = (error) => {
			reject(error);
		}
	})
}



export function stringToColor(string) {
	let hash = 0;
	let i;

	/* eslint-disable no-bitwise */
	for (i = 0; i < string.length; i += 1) {
		hash = string.charCodeAt(i) + ((hash << 5) - hash);
	}

	let color = '#';

	for (i = 0; i < 3; i += 1) {
		const value = (hash >> (i * 8)) & 0xff;
		color += `00${value.toString(16)}`.slice(-2);
	}
	/* eslint-enable no-bitwise */

	return color;
}
//////////////////////////////////////////////////////////////////////////////////////////////////////
export const myDateToTimestamp = (d) => {

	if (d) {
		let myd = d
		if (typeof d === 'string' || d instanceof String) {
			try {
				const tmp_d = parse(d, 'HH:mm', new Date())
				myd = firebase.firestore.Timestamp.fromDate(tmp_d)
			} catch (err) {

			}
		} else {
			try {
				try {
					//console.log(d)
					myd = d.toDate()
				} catch (err) {

				}
				myd = firebase.firestore.Timestamp.fromDate(myd)
			} catch (err) {
				//console.error(err)
			}

		}

		return myd
	} else {
		//console.error("EMPTY DATE")
		return ''
	}
}

////////////////////////////////////////////////////////////////////////////////////////////////////////
/**
 * return javascript Date() object or original object (new Date if empty)
 * @param {d} d date in Timestamp format (from firebase) 
 */
export const myTimestampToDate = (d) => {
	if (d) {
		let myd = d
		try {
			if (d._seconds) {
				//d = new firebase.firestore.Timestamp(d._seconds, d._nanoseconds)
			}
			myd = d.toDate()
		} catch (err) {
			//			console.error("date error conversion", err, d, myd)
		}
		return myd
	} else {
		console.error("date error conversion(NO DATE)", d)
		return new Date()
	}
}
export function parseDate(input, format) {
	format = format || 'dd/mm/yyyy'; // some default format
	var parts = input.match(/(\d+)/g),
		i = 0,
		fmt = {};
	// extract date-part indexes from the format
	format.replace(/(yyyy|dd|mm)/g, function (part) { fmt[part] = i++; });
	return new Date(parts[fmt['yyyy']], parts[fmt['mm']] - 1, parts[fmt['dd']])
}


export const myFormat = (d) => {
	try {
		return format(myTimestampToDate(d), 'dd/MM/yyyy')
	} catch (err) {
		console.log("ERROR DATE", d)
		return ''

	}
}



export const getCategoryColor = (l) => {
	if (l === 0) {
		return '#aaa'
	} else if (l === 1) {
		return 'orange'
	} else {
		return 'black'
	}
}



export const chunk = (arr, size) =>
	Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
		arr.slice(i * size, i * size + size)
	);
